import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
import { useLanguage } from "../../context/LanguageContext";

function AboutCard() {
  const { t } = useLanguage();

  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            {t("about.greeting")}{" "}
            <span className="purple">Zainal Salamun</span>,{" "}
            {t("about.identity")}{" "}
            <span className="purple">Jakarta, Indonesia.</span>
            <br />
            {t("about.currentPrefix")}{" "}
            <span className="purple">
              {t("about.currentRole")}
            </span>
            , {t("about.currentSuffix")}
            <br />
            {t("about.education")}
            <br />
            <br />
            {t("about.experience")}
            <br />
            <br />
            {t("about.architecture")}
            <br />
            <br />
            {t("about.activities")}
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> {t("about.sports")}
            </li>
            <li className="about-activity">
              <ImPointRight /> {t("about.reading")}
            </li>
            <li className="about-activity">
              <ImPointRight /> {t("about.travel")}
            </li>
          </ul>

          <p style={{ color: "#fff" }}>
            "Stay hungry stay foolish"{" "}
          </p>
          <footer className="blockquote-footer">Steve Jobs</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}
export default AboutCard;
